import React from 'react';
import { round, map, sum } from 'lodash';

import Table from 'UI/Table';
import { filteredVMs } from './Data';
import VMTable from './VMTable';
import { humanizeGB, humanizeMB } from 'Decorators/SizeDecorator'

const ClusterFunctionTable = ({ cluster_functions, filters, billing, vmsToUpdate, updateVMs }) => {
  const buildColumn = (field, humanize = true, humanizeFunction = humanizeGB) => ({
    accessor: clusterFunction => {
      const vms = filteredVMs(clusterFunction.vms, filters)
      const vmFields = map(vms, vm => parseInt(vm[field]))

      return round(sum(vmFields), 2)
    },
    Cell: ({ value }) => humanize ? humanizeFunction(value) : value
  });

  return (
    <Table {...{
      data: cluster_functions,
      columns: [
        { Header: 'Cluster', accessor: 'name' },
        { Header: 'Function', accessor: 'function' },
        { Header: 'VM Count', id: 'vm_count', type: 'number', accessor: clusterFunction => filteredVMs(clusterFunction.vms, filters).length },
        { Header: 'Number of CPUs', id: 'customer_cpu', type: 'number', ...buildColumn('num_cpu', false) },
        { Header: 'Memory', id: 'customer_memory_gb', type: 'number', ...buildColumn('memory_gb') },
        { Header: 'Memory (Reserved)', id: 'customer_memory_reserved', type: 'number', ...buildColumn('memory_reservation_mb', true, humanizeMB) },
        { Header: 'Allocated Space', id: 'customer_allocated_space_gb', type: 'number', ...buildColumn('allocated_space_gb') },
        { Header: 'Provisioned Space', id: 'customer_provisioned_space_gb', type: 'number', ...buildColumn('provisioned_space_gb') },
        { Header: 'Used Space', id: 'customer_used_space_gb', type: 'number', ...buildColumn('used_space_gb') },
      ],
      defaultSorted: [{ id: 'function', asc: true }],
      showPagination: false,
      defaultPageSize: cluster_functions.length,
      collapseOnDataChange: false,
      SubComponent: (row) => <VMTable {...{ vmsToUpdate, updateVMs, billing, vms: filteredVMs(row.original.vms, filters) }} />
    }} />
  );
};

export default ClusterFunctionTable
